<button nbButton *ngIf="!getValue()" [status]="buttonStyle" size="small" (click)="openScopeSelectionDialogProcess()">
    <nb-icon icon="plus-outline"></nb-icon>
    Add
</button>
<button nbButton *ngIf="getValue()" status="control" size="small" (click)="openScopeSelectionDialogProcess()">
    <nb-icon icon="edit-outline"></nb-icon>
    {{ getValue() }}
</button>
